export default "__VITE_ASSET__Dy82slWh__"